import { connect } from 'react-redux';
import { createStructuredSelector, createSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import FrameworkUtils from 'utils/framework';
import CreditCard from 'components/FrictionlessCheckout/PaymentReleaseFour/CreditCard/CreditCard';
import CreditCardEN from 'components/FrictionlessCheckout/PaymentReleaseFour/CreditCard/locales/CreditCard_en_US';
import CreditCardFR from 'components/FrictionlessCheckout/PaymentReleaseFour/CreditCard/locales/CreditCard_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(CreditCardEN, CreditCardFR);

const localization = createStructuredSelector({
    defaultCard: getTextFromResource(getText, 'defaultCard'),
    exp: getTextFromResource(getText, 'exp')
});

const fields = createSelector(localization, locales => {
    return {
        locales
    };
});

const withCreditCardProps = wrapHOC(connect(fields, null));

export default withCreditCardProps(CreditCard);
